// extracted by mini-css-extract-plugin
module.exports = {"duration":"clinical-portal-3__CallDuration__duration"};